// extracted by mini-css-extract-plugin
export default {"container":"SSOSignIn_container__2fep-"};